import {
  AGE_ACQUISITION_LINKS_CTA_IN_PODS_MODULE,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { useSpecificOptimizelyUserDecision } from '../optimizely-for-client'

export function usePodsShowCta(useDecisions: boolean = false): boolean {
  const decision = useSpecificOptimizelyUserDecision(
    AGE_ACQUISITION_LINKS_CTA_IN_PODS_MODULE,
    useDecisions,
  )

  return decision?.variationKey === OPTIMIZELY_VARIANT_KEYS.WITH_LINK
}
